module.exports = __webpack_public_path__ + "static/media/information_notes.dd247dcb.jpg";